const YM_ID = 90010721;
// Клиентские редиректы роутера (например "/" -> "/today") завершаются асинхронно,
// поэтому hit откладываем и отправляем только конечный URL цепочки переходов.
const HIT_DELAY_MS = 300;

// Счётчик инициализируется с defer: true (public/index.html), поэтому все просмотры,
// включая первый, отправляем отсюда — уже после клиентских редиректов роутера.
let lastUrl = null;
let pendingHit = null;

const sendHit = () => {
    pendingHit = null;
    const url = window.location.href;
    if (url === lastUrl) return;

    const options = lastUrl ? { referer: lastUrl, title: document.title } : { title: document.title };
    lastUrl = url;
    window.ym?.(YM_ID, 'hit', url, options);
};

export const trackPageView = () => {
    clearTimeout(pendingHit);
    pendingHit = setTimeout(sendHit, HIT_DELAY_MS);
};
